import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcompanhamentoSangriaPostoMainComponent } from './acompanhamento-sangria-posto-main/acompanhamento-sangria-posto-main.component';
import { GlobalModule } from 'src/app/global/global.module';

@NgModule({
  declarations: [AcompanhamentoSangriaPostoMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class AcompanhamentoSangriaPostoModule {}
